export const APP_NAME = "Fortunescope";

export const APPSFLYER_LINK = `https://fortunescope.onelink.me/AiCD`;
